/* TargetFilesRenderer.js */

"use strict";
// const MoveVeilComponent = require("./../../move_veil/MoveVeilComponent");
const _ = require("lodash");
class TargetFilesRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("target-column");
        this._rootElem.component = this._model;
        this._imageSequence = undefined;
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._imageSequence = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("TargetFiles", (this._onTargetFiles = this._onTargetFiles.bind(this)));
        this._rootElem.addEventListener(
            "click",
            (this._onClickEditIcon = this._onClickEditIcon.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeAllListeners("TargetFiles");
        this._rootElem.removeEventListener("click", this._onClickEditIcon);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setTargetFiles(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onTargetFiles(newVal) {
        this._setTargetFiles(newVal);
    }

    _onClickEditIcon() {
        if (this._model._isCompleted) {
            //clickable?
            return;
        }
        this._model._switchToEditImage();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setTargetFiles(value) {
        if (value.imageAssociations && !_.isEmpty(value.imageAssociations[this._model._id])) {
            this._imageSequence = value.imageAssociations[this._model._id].imageIds;
            if (this._imageSequence.length > 0) {
                this._model._gameEditor
                    ._getImageNameByIds(this._imageSequence)
                    .then((images) => {
                        /* Sort the images based on the entity */
                        images.sort((a, b) => {
                            return (
                                this._imageSequence.indexOf(_.get(a, "id")) -
                                this._imageSequence.indexOf(_.get(b, "id"))
                            );
                        });
                        /* Sort the images based on the entity */

                        let selectedImage = images.map((image) => {
                            return image.name;
                        });
                        if (selectedImage.length > 0 && this._rootElem) {
                            this._rootElem.innerHTML = selectedImage.join(", ");
                            this._rootElem.title = selectedImage.join("\n");
                        }
                    })
                    .catch((err) => {
                        if (this._rootElem) {
                            this._rootElem.innerHTML = "Select Edit to choose files";
                        }
                        console.warn(err);
                    });
            } else {
                this._rootElem.innerHTML = "Select Edit to choose files";
            }
        } else {
            this._rootElem.innerHTML = "Select Edit to choose files";
        }

        if (this._model._isCompleted) {
            //clickable?
            this._rootElem.classList.remove("enabled");
        } else {
            this._rootElem.classList.add("enabled");
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = TargetFilesRenderer;
